var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',{ref:"tree",attrs:{"data":_vm.permTree,"show-checkbox":"","node-key":"permId","default-expand-all":"","check-strictly":false,"default-checked-keys":_vm.defaultCheckeds,"props":_vm.defaultProps},on:{"check-change":_vm.nodeCheck}})
}
var staticRenderFns = []

export { render, staticRenderFns }